import { captureBrowserAttributionIds } from "@/lib/attribution/browser-ids"
import { persistFbcDocumentCookie } from "@/lib/attribution/fbc-cookie"
import { extractUtmClickBundleFromUrl } from "@/lib/attribution/extract-utm-from-url"
import { readStickyAcquisitionCampaign } from "@/lib/attribution/sticky-acquisition-client"
import type { SignupAttributionContext } from "@/lib/attribution/types"

export type SignupBrowserIdOverlay = Pick<
  SignupAttributionContext,
  "fbp" | "fbc" | "gaClientId" | "fbclid"
>

/**
 * Recaptura IDs de cookie no submit do cadastro.
 * O bootstrap lê `_ga`/`_fbp` cedo demais; no POST o overlay preenche o signup_touch.
 */
export function buildSignupBrowserIdOverlay(args: {
  cookieHeader: string
  pageUrl?: string | null
  storedFbc?: string | null
  nowMs?: number
}): SignupBrowserIdOverlay {
  let fbclid: string | null = null
  if (args.pageUrl?.trim()) {
    try {
      fbclid = extractUtmClickBundleFromUrl(new URL(args.pageUrl)).fbclid
    } catch {
      fbclid = null
    }
  }
  if (!fbclid) {
    fbclid = readStickyAcquisitionCampaign()?.fbclid ?? null
  }

  const ids = captureBrowserAttributionIds({
    cookieHeader: args.cookieHeader,
    fbclid,
    storedFbc: args.storedFbc,
    nowMs: args.nowMs,
  })

  if (ids.fbc) {
    persistFbcDocumentCookie(ids.fbc)
  }

  return {
    fbp: ids.fbp,
    fbc: ids.fbc,
    gaClientId: ids.gaClientId,
    fbclid,
  }
}
